import React from 'react'
import SideMenu from './SideMenu'
import GovernanceHero from '../governance/GovernanceHero'
import { newpaperannounce } from '../../js/NewspaperAnnounce';

function NewspaperAdvertisements() {
    return (
        <div>
            <GovernanceHero headingText={'Stock Exchange'} />

            <div className='mx-auto max-w-7xl py-8'>
                <div className='md:flex lg:flex xl:flex 2xl:flex'>
                    <div className='lg:px-6 md:px-6 xl:px-6 px-2 md:pb-6 lg:pb-6 xl:pb-6 pb-4 max-w-4xl w-full'>
                        <h2 class="my-4 text-2xl text-gray-700 font-bold">Newspaper Advertisements</h2>


                        <div class="relative overflow-x-auto  p-2">

                            <table class=" text-sm text-left rtl:text-right text-gray-500">
                                <thead class="text-xs text-gray-700 uppercase">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 ">
                                            Date
                                        </th>
                                        <th scope="col" class="px-6 py-3 ">
                                            Quarter/Year ended
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            Notice of Board Meeting
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            Financial Results
                                        </th>
                                    </tr>
                                </thead>

                                {newpaperannounce.map(news => (
                                    <tbody>
                                        <tr class="border-b border-gray-200 ">
                                            <td class="px-6 py-4">
                                                {news.Heading1}
                                            </td>
                                            <td class="px-6 py-4">
                                                {news.Heading2}
                                            </td>
                                            <td class="px-6 py-4 text-[#2baf2b]">
                                                < a href={news.PDF1} target="_blank" rel="noopener noreferrer">
                                                    Download
                                                </a>
                                            </td>

                                            <td class="px-6 py-4 text-[#2baf2b]">
                                                < a href={news.PDF2} target="_blank" rel="noopener noreferrer">
                                                    Download
                                                </a>
                                            </td>
                                        </tr>

                                    </tbody>
                                ))}
                            </table>
                        </div>


                    </div>

                    <div className='md:px-0 lg:px-0 xl:px-0 2xl:px-0 px-3.5'>
                        <SideMenu />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewspaperAdvertisements